import { DEMO_PARTY_OVERRIDES } from '@/constants/demo';
import type { Party } from '@/features/party/types';

function isSameEmail(a: Maybe<string>, b: Maybe<string>) {
  if (!a || !b) return false;

  return a.trim().toLowerCase() === b.trim().toLowerCase();
}

function includesBrokerEmail(configured: string, brokerEmail: Maybe<string>) {
  const needle = configured.trim().toLowerCase();
  if (!needle || !brokerEmail) return false;

  return brokerEmail.trim().toLowerCase().includes(needle);
}

export function applyDemoPartyOverrides<T extends Party>(
  party: T,
  brokerEmail: Maybe<string>,
): T {
  const override = DEMO_PARTY_OVERRIDES.find(
    (entry) =>
      includesBrokerEmail(entry.brokerEmail, brokerEmail) &&
      isSameEmail(entry.partyEmail, party.email),
  );

  if (!override) return party;

  return { ...party, ...override.overrides } as T;
}

export function applyDemoPartyOverridesToList<T extends Party>(
  parties: T[],
  brokerEmail: Maybe<string>,
): T[] {
  return parties.map((party) => applyDemoPartyOverrides(party, brokerEmail));
}
